import axios from 'axios';

import URLS from '../../util/urls.js';

const state = {
  imovelDisponivelPesquisa: {
    operacao: undefined,
    tipoImovel: undefined,
    valorInicial: 0,
    valorFinal: 0,
    area: undefined,
    quartos: undefined,
    suites: undefined,
    idNaImobiliaria: undefined,
    endereco: undefined,
    status: "DISPONIVEL",
    pagina: 0
  },
  listaImoveisDisponiveis: [],
  imovelParceriaPesquisa: { pagina: 0 },
  listaImoveisParceria: []
};
const mutations = {
  limparImovelDisponivelPesquisa(state) {
    state.imovelDisponivelPesquisa = {
      operacao: undefined,
      tipoImovel: undefined,
      valorInicial: 0,
      valorFinal: 0,
      area: undefined,
      quartos: undefined,
      suites: undefined,
      idNaImobiliaria: undefined,
      endereco: undefined,
      status: "DISPONIVEL",
      pagina: 0
    };
  },
  atualizarListaImoveisDisponiveis(state, payload) {
    if(state.imovelDisponivelPesquisa.pagina === 0) {
      state.listaImoveisDisponiveis = payload.lista;
    } else {
      state.listaImoveisDisponiveis.push(...payload.lista);
    }
  },
  limparImoveisDisponiveisListados(state) {
    state.listaImoveisDisponiveis = [];
  },
  limparImoveisParceriaListados(state) {
    state.listaImoveisParceria = [];
  },
  atualizarListaImoveisParceria(state, payload) {
    if(state.imovelParceriaPesquisa.pagina === 0) {
      state.listaImoveisParceria = payload.lista;
    } else {
      state.listaImoveisParceria.push(...payload.lista);
    }
  },
  adicionarAParceria(state, payload) {
    state.listaImoveisParceria.push(...payload);
  },
  removerDaParceria(state, payload) {
    let idsImoveisASeremRemovidos = payload
      .map((imovel) => {
        return imovel.id;
      });

    state.listaImoveisParceria = state.listaImoveisParceria
      .filter((imovel) => {
        return !idsImoveisASeremRemovidos.includes(imovel.id);
      });
  }
};
const actions = {
  limparImovelDisponivelPesquisa(context) {
    context.commit('limparImovelDisponivelPesquisa');
  },
  listarImoveis(context, payload) {
    return axios.post(URLS.IMOVEIS_LISTAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaImoveisDisponiveis', response.data);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('listarImoveis', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  limparImoveisDisponiveisListados(context) {
    context.commit('limparImoveisDisponiveisListados');
  },
  limparImoveisParceriaListados(context) {
    context.commit('limparImoveisParceriaListados');
  },
  listarImoveisDisponiveisParceria(context, payload) {
    return axios.post(URLS.PARCERIAS_LISTAR_DISPONIVEIS_PARCERIA, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaImoveisParceria', response.data);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('listarImoveisDisponiveisParceria', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  adicionarAParceria(context, payload) {
    context.commit('adicionarAParceria', payload);
  },
  removerDaParceria(context, payload) {
    context.commit('removerDaParceria', payload);
  },
  gravarImoveisParceria(context, payload) {
    return axios.post(URLS.PARCERIAS_GRAVAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('gravarImoveisParceria', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  gerarRelatorioImoveisParceria(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('gerarRelatorioImoveisParceria', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  }
};

export default {
  state,
  mutations,
  actions
};